import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import { Modal, Form, Row, Col, Input, Select, Button } from 'antd'
import {withTranslation} from 'react-i18next'
const {TextArea} = Input
@inject('marketingSmsManagementStore', 'intelligentOutboundCallStore')
@observer
class FormModal extends Component {
  state = {
  }

  formRef = React.createRef()

  componentDidMount() {
  }

  handleOk = () => {
    const {marketingSmsManagementStore, intelligentOutboundCallStore, handleCancel, groupId, taskId, isCall} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = isCall ? {
          "approveStatus": 'REJECTED',
          "taskId": taskId,
          "comment": fieldsValue?.refuseReason,
        } : {
        "approveResult": '4',
        "groupId": groupId,
        "refuseReason": fieldsValue?.refuseReason,
        "taskId": taskId,
      }
      if(isCall) {
        intelligentOutboundCallStore.onAgreeAction(params).then(res=> {
          if (res?.data?.code === 0) {
            handleCancel()
          }
        })
      } else {
        marketingSmsManagementStore.onAgreeAction(params).then(res=> {
          if (res?.data?.code === 0) {
            handleCancel()
          }
        })
      }
    }).catch(() => {})
  }

  render() {
    const { addModalVisible, handleCancel, title, t } = this.props
    return (
      <>
        <Modal
          title={t(`marketingManagement.refuseReason`)}
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk} >{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addMapping" layout="vertical">
            <Row gutter={[10, 10]}>
              <Col span={24} >
                <Form.Item name='refuseReason' label={t(`marketingManagement.refuseReason`)} rules={[{ required: true, message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.refuseReason`)}`}]}>
                  <TextArea maxLength={100} rows={4} placeholder={t(`general.pleaseEnter`)} style={{width: '100%'}} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
